import "./summaryPagePortal.scss";
import { createPDF } from "../../../../core/customFunctions/createPDF";
import { toggleLoad } from "../../../../core/3d-configurator";

export function summaryPagePortalComponent(container) {
  const existingPortals = document.querySelectorAll('#sum-portal');
  existingPortals.forEach(portal => portal.remove());

  let currentActionType = "quote";
  const uniqueId = `summary-form-${Date.now()}`;

  const config = {
    quote: {
      buttonText: "Submit",
      submitAction: async (formData) => {
        try {
          toggleLoad(true);
          const pdfBlob = await createPDF();

          if (!pdfBlob) {
            throw new Error('Failed to generate PDF');
          }

          const formDataToSend = new FormData();
          formDataToSend.append('firstName', formData.firstName);
          formDataToSend.append('lastName', formData.lastName);
          formDataToSend.append('email', formData.email);
          formDataToSend.append('phone', formData.phone.replace(/\D/g, ''));
          formDataToSend.append('address', formData.address);
          formDataToSend.append('configuratorLink', window.location.href);
          formDataToSend.append('pdf', pdfBlob, 'configurator-summary.pdf');

          const response = await fetch('https://back-hideaway-pergola-app-5nbjq.ondigitalocean.app/submit-form', {
            method: 'POST',
            body: formDataToSend
          });

          const result = await response.json();

          if (result.success) {
            return { success: true };
          } else {
            return { success: false, message: result.message };
          }
        } catch (error) {
          console.error('Error submitting quote:', error);
          return { success: false, message: 'Error submitting quote. Please try again.' };
        } finally {
          toggleLoad(false);
        }
      }
    },
    pdf: {
      buttonText: "Download PDF",
      submitAction: async (formData) => {
        console.log('>>> PDF submitAction called');
        try {
          toggleLoad(true);
          console.log('>>> Calling createPDF...');
          const pdfResult = await createPDF();
          toggleLoad(false);
          return { success: true };
        } catch (error) {
          console.error('>>> PDF generation error:', error);
          toggleLoad(false);
          return { success: false, message: 'Failed to generate PDF' };
        }
      }
    }
  };

  const htmlString = `
  <div class='summary-portal' id='sum-portal' style="display: none;">
    <div class="form-container">
      <form class="form" id="${uniqueId}" novalidate>
        <div class="form__header">
          <h2 class="form__header__title">Please, fill in details below: </h2>
          <button type="button" class="form__header__close close-form-btn"></button>
        </div>
        
        <div class="form__top">
          <div class="form__group">
            <div class="form__group-header">
              <label for="form_firstName">First name<span class="required">*</span></label>
            </div>
            <input class="form__input" id="form_firstName" type="text" name="firstName" placeholder="John" required minlength="2"/>
            <span class="error-message firstname-error"></span>
          </div>
          
          <div class="form__group">
            <div class="form__group-header">
              <label for="form_lastName">Last name<span class="required">*</span></label>
            </div>
            <input class="form__input" id="form_lastName" type="text" name="lastName" placeholder="Johnson" required minlength="2"/>
            <span class="error-message lastname-error"></span>
          </div>
        </div>
        
        <div class="form__middle">
          <div class="form__group">
            <div class="form__group-header">
              <label for="form_email">Email<span class="required">*</span></label>
            </div>
            <input class="form__input" id="form_email" type="email" name="email" placeholder="example@example.com" required/>
            <span class="error-message email-error"></span>
          </div>
          
          <div class="form__group">
            <div class="form__group-header">
              <label for="form_phone">Phone<span class="required">*</span></label>
            </div>
            <input class="form__input" id="form_phone" type="tel" name="phone" inputmode="numeric" placeholder="(000) 000-0000"
              pattern="[0-9]*" 
              onkeydown="return (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || [8, 9, 13, 46, 37, 38, 39, 40].includes(event.keyCode) || (event.ctrlKey || event.metaKey)" 
              required/>
            <span class="error-message phone-error"></span>
          </div>
        </div>
        
        <div class="form__bottom">
          <div class="form__group form__group--full">
            <div class="form__group-header">
              <label for="form_address">Address<span class="required">*</span></label>
            </div>
            <input class="form__input" id="form_address" type="text" name="address" placeholder="123 Main Street, 74, New York, 12345" required/>
            <span class="error-message address-error"></span>
          </div>
        </div>
        
        <div class="form__check">
          <div class="form__check_label">
            <input type="checkbox" id="agree" name="agree" class="form__check-input" required>
            <label for="agree" class="form__check__label">
              <span class="checkbox-icon"></span>
              <span class="checkbox-item__label-text">I confirm that my information can be used solely to handle this request and will not be shared with third parties.</span>
            </label>
          </div>
          <span class="error-message agree-error"></span>
        </div>
        
        <div class="form__buttons">
          <button type="button" class="form__buttons__button form__buttons__button--back cancel-form-btn" id="js-closeRequest">Cancel</button>
          <button type="submit" class="form__buttons__button action-form-btn" id="js-submitRequest">Request Quote</button>
        </div>
      </form>

      <!-- success message-->
      <div class="request_message_submitted" style="display: none;">
         <div class="success-message-content">
            <h3 class="success-message-title">Thanks for your submission.</h3>
               <p class="success-message-text">
                A HIDEAWAY sales member will be in touch very shortly.
               </p>
               <p class="success-message-text">
              They can also be reached at <a href="mailto:sales@hideaway.inc">sales@hideaway.inc</a> for any further queries.
               </p>
          </div>
      </div>
  `;

  let containerElement;

  if (typeof container === 'string') {
    containerElement = document.querySelector(container);
  } else if (container && container.jquery) {
    containerElement = container[0];
  } else if (container instanceof HTMLElement) {
    containerElement = container;
  } else {
    containerElement = document.body;
  }

  if (!containerElement) {
    console.error('Container not found:', container);
    containerElement = document.body;
  }

  containerElement.insertAdjacentHTML('beforeend', htmlString);
  const testMessage = document.querySelector('.request_message_submitted');
  const summaryPortal = document.getElementById('sum-portal');
  const form = document.getElementById(uniqueId);

  if (!form) {
    console.error('Form not found after insertion!');
    return;
  }

  const submitButton = form.querySelector('#js-submitRequest');
  const cancelButton = form.querySelector('#js-closeRequest');
  const popupClose = summaryPortal.querySelector('.close-form-btn');

  function showError(field, message) {
    field.classList.add('error');
    const errorElement = field.closest('.form__group').querySelector('.error-message');
    if (errorElement) {
      errorElement.textContent = message;
    }
  }

  function validateForm() {
    let isValid = true;

    form.querySelectorAll('.error-message').forEach(el => el.textContent = '');
    form.querySelectorAll('input').forEach(el => {
      el.classList.remove('error');
    });

    const firstName = form.querySelector('input[name="firstName"]');
    if (!firstName.value.trim()) {
      showError(firstName, 'Please enter your first name');
      isValid = false;
    } else if (firstName.value.trim().length < 2) {
      showError(firstName, 'First name must be at least 2 characters long');
      isValid = false;
    }

    const lastName = form.querySelector('input[name="lastName"]');
    if (!lastName.value.trim()) {
      showError(lastName, 'Please enter your last name');
      isValid = false;
    } else if (lastName.value.trim().length < 2) {
      showError(lastName, 'Last name must be at least 2 characters long');
      isValid = false;
    }

    const email = form.querySelector('input[name="email"]');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.value.trim()) {
      showError(email, 'Please enter your email');
      isValid = false;
    } else if (!emailRegex.test(email.value.trim())) {
      showError(email, 'Please enter a valid email address');
      isValid = false;
    }

    const phone = form.querySelector('input[name="phone"]');
    const phoneDigits = phone.value.replace(/\D/g, '');
    if (!phoneDigits) {
      showError(phone, 'Please enter your phone number');
      isValid = false;
    } else if (phoneDigits.length < 10) {
      showError(phone, 'Phone number must be at least 10 digits');
      isValid = false;
    }

    const address = form.querySelector('input[name="address"]');
    if (!address.value.trim()) {
      showError(address, 'Please enter your address');
      isValid = false;
    } else if (address.value.trim().length < 5) {
      showError(address, 'Please enter a valid address');
      isValid = false;
    }

    const agree = form.querySelector('input[id="agree"]');
    const checkboxWrapper = agree.closest('.form__check');
    const checkboxError = checkboxWrapper.querySelector('.error-message');
    if (!agree.checked) {
      agree.classList.add('error');
      if (checkboxError) {
        checkboxError.textContent = 'You must agree to the terms';
      }
      isValid = false;
    }

    return isValid;
  }

  function showSuccessMessage() {
    const messageElement = summaryPortal.querySelector('.request_message_submitted');
    const formElement = form;

    if (messageElement && formElement) {

      formElement.style.display = 'none';
      messageElement.style.display = 'block';

      setTimeout(() => {
        messageElement.style.display = 'none';
        formElement.style.display = 'block';
        form.reset();
        summaryPortal.style.display = 'none';
        document.body.classList.add('body-overflow-auto');
      }, 3000);
    } else {
      console.error('elements not found', {
        messageElement: !!messageElement,
        formElement: !!formElement
      });
    }
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    submitButton.disabled = true;
    const originalButtonText = submitButton.textContent;
    submitButton.textContent = 'Processing...';

    const formData = {
      firstName: form.querySelector('input[name="firstName"]').value,
      lastName: form.querySelector('input[name="lastName"]').value,
      email: form.querySelector('input[name="email"]').value,
      phone: form.querySelector('input[name="phone"]').value,
      address: form.querySelector('input[name="address"]').value,
    };

    const result = await config[currentActionType].submitAction(formData);
    submitButton.disabled = false;
    submitButton.textContent = originalButtonText;

    if (result && result.success !== false) {
      if (currentActionType === 'quote') {
        showSuccessMessage();
      } else if (currentActionType === 'pdf') {
        form.reset();
        summaryPortal.style.display = 'none';
        document.body.classList.add('body-overflow-auto');
      }
    }
  });

  if (popupClose) {
    popupClose.addEventListener('click', () => {
      summaryPortal.style.display = 'none';
      document.body.classList.add('body-overflow-auto');
    });
  }

  cancelButton.addEventListener('click', () => {
    form.reset();
    form.querySelectorAll('.error-message').forEach(el => el.textContent = '');
    form.querySelectorAll('input').forEach(el => {
      el.classList.remove('error');
    });
    summaryPortal.style.display = 'none';
    document.body.classList.add('body-overflow-auto');
  });

  window.setSummaryFormAction = function (actionType) {

    const form = document.getElementById(uniqueId);
    const submitBtn = form ? form.querySelector('#js-submitRequest') : null;

    if (config[actionType] && submitBtn) {
      currentActionType = actionType;
      submitBtn.textContent = config[actionType].buttonText;
    } else {
      console.error('Invalid action type or button not found:', actionType);
    }
  };
}